// Resolves the correct backend base URL at runtime.
//
// On localhost (dev), use REACT_APP_BACKEND_URL from .env so the frontend can
// reach a backend running on a different host/port.
//
// In every other environment (preview, staging, production custom domain),
// use the current window origin. Emergent's ingress routes /api/* to the
// backend pod attached to that domain, so same-origin calls always work and
// avoid all CORS pitfalls.
function resolveApiBase() {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  const host = window.location.hostname;
  const isLocalDev = host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local');
  if (isLocalDev) {
    return process.env.REACT_APP_BACKEND_URL || window.location.origin;
  }
  return window.location.origin;
}

export const API_BASE = resolveApiBase();
